import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  AlertController,
  ModalController,
  NavController,
} from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { BuildingService } from "src/app/app/building/building.service";
import { CompanyService } from "src/app/app/company/company.service";
import { DictionaryService } from "src/app/dictionary/dictionary.service";
import { HeaderModel } from "src/app/_component/header/header.model";
import { ThisPlatform } from "src/app/_services/platform.service";
import { PaginationClientSideOptions } from "../../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../../_component/pagination-client-side/pagination-column.class";
import { RowsLoaderService } from "../../../_services/rows-loader.service";
import { ReportTaskViewComponent } from "../report-task-view/report-task-view.component";
import { AddReportTaskPage } from "../report-task/add-report-task/add-report-task.page";
import { ReportTask } from "../report-task/report-task.model";
import { ReportTaskService } from "../report-task/report-task.service";
import { ReportService } from "../report.service";
import { ReportTaskModalComponent } from "../report-task/report-task-modal/report-task-modal.component";
import { HeaderService } from "src/app/_services/header.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-edit-report",
  templateUrl: "./edit-report.page.html",
  styleUrls: [
    "./edit-report.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class EditReportPage {
  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    public alertController: AlertController,
    public reportServ: ReportService,
    private navCtrl: NavController,
    public buildingServ: BuildingService,
    public dictionaryServ: DictionaryService,
    public companyServ: CompanyService,
    public reportTaskServ: ReportTaskService,
    private location: Location,
    public p: ThisPlatform,
    private modalCtrl: ModalController,
    private headerServ: HeaderService,
  ) {}

  subscription: Subscription = new Subscription();

  reportId: string;
  componentRef: any = ReportTaskViewComponent;
  buildingName: string;
  locationName: string;

  isError: boolean = false;
  loadingTask: boolean = false;

  errorStatus: number;

  columnsDefinition: PaginationColumn[] = [
    {
      name: "createdAt",
      displayName: "REPORT_TASK.DATE",
      size: 3,
      sortable: true,
    },
    {
      name: "assignmentBy",
      displayName: "REPORT_TASK.TASK_FROM",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.assignmentBy.firstName + row.assignmentBy.lastName;
      },
    },
    {
      name: "performedBy",
      displayName: "REPORT_TASK.TASK_TO",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.performedBy.firstName + row.performedBy.lastName;
      },
    },
    {
      name: "priority",
      displayName: "REPORT_TASK.PRIORITY",
      size: 2,
      sortable: false,
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mainStyle: "gray-md-rows",
    gridColumnsCount: 12,
    permissionEdit: true,
    permissionSpaceAdd: true,
    mobileViewBreakPoint: 900,
    headerEmitClick: true,
    // customData: "true",
  };

  rowsLoader: RowsLoaderService;

  headerInit: HeaderModel = {
    title: "REPORT.EDIT_REPORT",
    backDefaultHref: "/app/report",
    showRightButtonsOnlyOnMobile: true,
    rightButtons: [
      {
        iconName: "trash",
        rolePermission: ["report.delete"],
        onClick: () => this.ReportDelete(),
      },
    ],
  };

  async ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
    await this.dictionaryServ.refreshDictionary();

    this.subscription.add(
      this.route.paramMap.subscribe((paramMap) => {
        if (!paramMap.has("ReportId")) {
          this.navCtrl.navigateBack("/report");
          return;
        }

        this.reportId = paramMap.get("ReportId");

        this.options.headerEmitClick = true;

        this.loadReportTasks();
      })
    );

  }

  async ReportDelete() {
    const alert = await this.alertController.create({
      header: this.translateService.instant("CONFIRM"),
      message: this.translateService.instant("QUESTION_DELETE"),
      buttons: [
        {
          text: this.translateService.instant("CANCEL"),
          role: "cancel",
          cssClass: "secondary",
          handler: () => {},
        },
        {
          text: "Ok",
          handler: () => {
            this.subscription.add(
              this.reportServ.deleteReport(this.reportId).subscribe((res) => {
                this.location.back();
              })
            );
          },
        },
      ],
    });

    await alert.present();
  }

  loadReportTasks() {
    this.loadingTask = true;
    this.reportTaskServ.reportTasks = [];
    this.subscription.add(
      this.reportTaskServ
        .getReportTasksByReportId(this.reportId)
        .subscribe({
          next: (reportTasks: ReportTask[]) => {
            this.reportTaskServ.reportTasks = reportTasks;
            this.rowsLoaderInit();
          },
          error: () => { this.loadingTask = false; },
          complete: () => { this.loadingTask = false; }
        })
    );
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  async addTask() {
    const modal = await this.modalCtrl.create({
      component: AddReportTaskPage,
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--edit-parking-space",
      componentProps: {
        reportId: this.reportId,
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role !== "backdrop") {
        this.loadReportTasks();
      }
    });
    modal.present();
  }

  async showTaskDetails(task) {
    const modal = await this.modalCtrl.create({
      component: ReportTaskModalComponent,
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--x-large",
      componentProps: {
        task: task,
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role !== "backdrop") {
        this.loadReportTasks();
      }
    });
    modal.present();
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.rowsLoader.init(this.reportTaskServ.reportTasks);
    }
  }

  selectedStatusChange(status: number) {
    this.reportServ.report.status = status;
  }

  save() {
    this.subscription.add(
      this.reportServ.updateReport().subscribe()
    );
  }
  onHTTPError(event: number) {
    this.isError = true;
    this.errorStatus = event;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
